import config from "../config";
import store from "../app/store";
import { validJSON } from "../common/utils";
import { showToast } from "../components/Toast/toast.slice";

const getOrgClientSettings = async (): Promise<any> => {
  const myHeaders = new Headers();
  myHeaders.append("content-type", "application/json");
  myHeaders.append("authorization", `${localStorage.userAccessToken}`);

  const requestOptions = {
    method: "GET",
    headers: myHeaders,
  };
  return new Promise((resolve, reject) => {
    const orgId = "1";
    fetch(
      `${config[config.env].apiEnspoints.accounts}/orgClientSettings/${orgId}
    `,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        if (validJSON(result)) {
          const organizationsResponse = JSON.parse(result);
          if (
            organizationsResponse.statusCode === 200 &&
            organizationsResponse.success
          ) {
            resolve(organizationsResponse);
          } else {
            throw organizationsResponse.error;
          }
        } else {
          const errorResponse = {
            error: "Error",
            message: "Invalid Response JSON Format",
            code: "Invalid JSON",
          };
          throw errorResponse;
        }
      })
      .catch((error: any) => {
        store.dispatch(showToast(error.details[0].message));
        reject(error);
      });
  });
};

export default getOrgClientSettings;
